module.exports = __webpack_public_path__ + "static/media/info.b055e54f.png";